/**
 * Converts a question type key to a human-readable label
 */
export function getQuestionTypeLabel(questionTypeKey?: string | null): string {
  if (!questionTypeKey) return 'Unknown';
  
  switch (questionTypeKey) {
    case 'freetext':
      return 'Free Text';
    case 'multiple-choice':
      return 'Multiple Choice';
    case 'boolean':
      return 'True or False';
    case 'single-selection':
      return 'Choose from a List';
    case 'specific-string':
      return 'Specific Value(s)';
    default:
      return questionTypeKey;
  }
}



